export const SKELETON_SIZES = {
  articles: {
    width: 258,
    height: 379
  },
  books: {
    width: 160,
    height: 239
  },
  newspaper: {
    width: 242,
    height: 418
  }
}
